import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';

const BAHistoryCoursePage: React.FC = () => {
  const courseData = {
    title: "B.A. History",
    shortName: "B.A. History",
    duration: "3 years",
    description: "Bachelor's degree program focused on historical studies, research, and analysis of past civilizations and events",
    overview: "Bachelor of Arts in History (B.A. History) is a 3-year undergraduate program that provides comprehensive study of world history, Indian history, archaeological studies, and historical research methods. This course covers ancient civilizations, medieval period, modern history, and contemporary historical developments, preparing students for careers in education, research, archaeology, and civil services.",
    eligibility: [
      "10+2 in any stream",
      "Minimum 50% marks in 12th standard",
      "Interest in historical studies and research",
      "Good analytical and reading skills"
    ],
    
    curriculum: [
      {
        year: 1,
        subjects: [
          "Ancient Indian History",
          "World History (Ancient)",
          "Historical Methods",
          "Archaeology and Epigraphy",
          "General English",
          "Computer Applications"
        ]
      },
      {
        year: 2,
        subjects: [
          "Medieval Indian History",
          "Modern World History",
          "Historiography",
          "Art and Architecture",
          "Economic History",
          "Research Methodology"
        ]
      },
      {
        year: 3,
        subjects: [
          "Modern Indian History",
          "Contemporary History",
          "Local and Regional History",
          "Historical Geography",
          "Project Work",
          "Field Study/Internship"
        ]
      }
    ],

    careerProspects: {
      roles: [
        "History Teacher",
        "Museum Curator",
        "Archaeologist",
        "Research Scholar",
        "Civil Services Officer",
        "Archivist",
        "Heritage Consultant",
        "Tour Guide",
        "Content Writer",
        "Documentary Researcher"
      ],
      industries: [
        "Education Sector",
        "Museums and Heritage Sites",
        "Archaeological Survey",
        "Government Services",
        "Tourism Industry",
        "Media and Publishing",
        "Research Institutions",
        "Cultural Organizations",
        "Non-Profit Sector",
        "Documentation Services"
      ],
      averageSalary: "₹3-6 LPA (Fresher), ₹10-30 LPA (Experienced in Govt)",
      topRecruiters: [
        "Archaeological Survey of India",
        "Government Schools/Colleges",
        "Museums and Heritage Sites",
        "UPSC, State PSCs",
        "Tourism Departments",
        "Research Institutions"
      ]
    },

    admissionProcess: [
      "Merit-based admission through 12th marks",
      "Some universities conduct entrance tests",
      "Direct admission in most colleges",
      "Cut-off based selection",
      "Online application process"
    ],

    topColleges: [
      {
        name: "Hindu College",
        location: "Delhi",
        fees: "₹25,000",
        ranking: "NIRF Ranking: 5"
      },
      {
        name: "St. Xavier's College",
        location: "Mumbai",
        fees: "₹35,000",
        ranking: "Autonomous College"
      },
      {
        name: "Presidency College",
        location: "Chennai",
        fees: "₹15,000",
        ranking: "Premier Government College"
      },
      {
        name: "Jadavpur University",
        location: "Kolkata",
        fees: "₹20,000",
        ranking: "State University"
      }
    ],

    skills: [
      "Historical Research",
      "Critical Analysis",
      "Academic Writing",
      "Data Interpretation",
      "Archaeological Methods",
      "Documentation Skills",
      "Public Speaking",
      "Cultural Awareness",
      "Time Management",
      "Analytical Thinking"
    ],

    futureScope: "Growing opportunities in heritage tourism, digital humanities, historical documentaries, cultural preservation, and increasing government focus on archaeological research.",

    faqs: [
      {
        question: "What career opportunities exist after B.A. History?",
        answer: "Career options include civil services, teaching, museum work, archaeology, heritage management, journalism, and research positions in government and private sectors."
      },
      {
        question: "Can I join civil services with History background?",
        answer: "Yes, History is an excellent optional subject for UPSC and many successful IAS officers have History background. It provides good foundation for general studies."
      },
      {
        question: "Are there opportunities in archaeology?",
        answer: "Yes, you can pursue M.A. in Archaeology or join Archaeological Survey of India. Many heritage sites and museums also recruit history graduates."
      },
      {
        question: "Can I work in media with History degree?",
        answer: "Yes, history graduates work in research for documentaries, historical content creation, cultural journalism, and educational media production."
      }
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-black flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow mb-6 text-center animate-glow">
        {courseData.title}
      </h1>
      <div className="w-full max-w-4xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default BAHistoryCoursePage;
